import { motion } from "framer-motion";
import { MaskedLines } from "@/components/Reveal";

const EASE = [0.22, 1, 0.36, 1];

export const PageHero = ({ eyebrow, titleLines, subtitle, testId = "page-hero" }) => (
  <section
    data-testid={testId}
    className="relative bg-navy-900 grain pt-40 pb-24 sm:pt-48 sm:pb-32 overflow-hidden"
  >
    <div className="absolute -left-24 top-10 h-80 w-80 rounded-full bg-emerald-brand/10 blur-3xl" />
    <div className="absolute right-0 bottom-0 h-72 w-72 rounded-full bg-navy-600/40 blur-3xl" />
    <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
      <motion.p
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, ease: EASE }}
        className="flex items-center gap-3 text-xs font-bold uppercase tracking-[0.3em] text-emerald-brand mb-6"
      >
        <span className="h-px w-10 bg-emerald-brand" />
        {eyebrow}
      </motion.p>
      <h1 className="font-heading font-extrabold text-white tracking-tighter leading-[0.95] text-5xl sm:text-6xl lg:text-7xl">
        <MaskedLines lines={titleLines} />
      </h1>
      {subtitle && (
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.5, ease: EASE }}
          className="mt-8 max-w-2xl text-lg leading-relaxed text-white/65"
        >
          {subtitle}
        </motion.p>
      )}
    </div>
  </section>
);
